import { CandidateDocumentType } from '../../shared/generated/models/CandidateDocumentType';
export var getCandidateContractorTypeMap = function getCandidateContractorTypeMap() {
  return {
    independentContractore: {
      value: 'independent_contractor',
      label: 'Independent'
    },
    paye: {
      value: 'paye',
      label: 'PAYE'
    }
  };
};
export var getCandidateContractorTypeList = function getCandidateContractorTypeList() {
  return Object.values(getCandidateContractorTypeMap());
};
export var getCandidateDocumentTypeMap = function getCandidateDocumentTypeMap() {
  return {
    attachment: {
      value: CandidateDocumentType.ATTACHMENT,
      label: 'Attachment'
    },
    resume: {
      value: CandidateDocumentType.RESUME,
      label: 'Resume'
    },
    insurance: {
      value: CandidateDocumentType.INSURANCE,
      label: 'Insurance'
    }
  };
};
export var getCandidateDocumentTypeList = function getCandidateDocumentTypeList() {
  return Object.values(getCandidateDocumentTypeMap());
};